import { FormInstance } from 'antd'
import { IWarehouseGoodsReceipt } from 'app/api/inventory-new/model/management'
import { IItem } from 'app/api/item/model'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { Dispatch, SetStateAction, createContext, useState } from 'react'

export interface IOrderItem extends IItem {
  quantity?: number
  price?: number
}
interface IWarehouseGoodsReceiptContext {
  orders?: IOrderItem[]
  setOrders?: Dispatch<SetStateAction<IItem[]>>
  purchaseOrders?: IOrderItem[]
  setPurchaseOrders?: Dispatch<SetStateAction<IItem[]>>
  form?: FormInstance
  discount?: number
  setDiscount?: Dispatch<SetStateAction<number>>
  warehouseGoodsReceiptDetail?: IWarehouseGoodsReceipt
  setWarehouseGoodsReceiptDetail?: Dispatch<SetStateAction<IItem>>
}
export const WarehouseGoodsReceiptContext =
  createContext<IWarehouseGoodsReceiptContext>({ orders: [] })

export const WarehouseGoodsReceiptProvider = ({ children }) => {
  const [orders, setOrders] = useState<IItem[]>([])
  const [purchaseOrders, setPurchaseOrders] = useState<IItem[]>([])
  const [warehouseGoodsReceiptDetail, setWarehouseGoodsReceiptDetail] = useState<IItem>(
    {},
  )
  const [form] = BaseForm.useForm()
  const [discount, setDiscount] = useState(0)

  return (
    <WarehouseGoodsReceiptContext.Provider
      value={{
        orders,
        setOrders,
        form,
        discount,
        setDiscount,
        warehouseGoodsReceiptDetail,
        setWarehouseGoodsReceiptDetail,
        setPurchaseOrders,
        purchaseOrders
      }}
    >
      {children}
    </WarehouseGoodsReceiptContext.Provider>
  )
}
